//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import styled from '@emotion/styled';

interface ToggleProps {
  disabled?: boolean;
  value: boolean;
  onChange: (val: boolean) => void;
}

const Toggle = ({ disabled, value, onChange }: ToggleProps) => {
  return (
    <Wrapper disabled={disabled} value={value} onClick={() => !disabled && onChange(!value)}>
      <Circle value={value} />
    </Wrapper>
  );
};

export default Toggle;

const Wrapper = styled.div<{ value: boolean; disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  width: 35px;
  height: 20px;
  ${(props) =>
    props.disabled
      ? `
      opacity: 0.5;
      cursor: not-allowed;
    `
      : `
      cursor: pointer;
    `};
  ${({ theme, value }) =>
    value
      ? `
		background: ${theme.palette.primary.main};
	`
      : `
		background: ${theme.palette.grey[theme.palette.mode === 'dark' ? 600 : 400]};
	`};
  border-radius: 999px;
`;

const Circle = styled.div<{ value: boolean }>`
  height: 16px;
  aspect-ratio: 1;
  border-radius: 999px;
  background: ${({ theme }) => (theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[700])};
  transition: margin 200ms ease-in-out;

  ${({ value }) =>
    value
      ? `
		margin-left: 17px;
    background: #ffffff;
	`
      : `
		margin-left: 2px;
	`};
`;
